import { ssrRef, useContext } from "@nuxtjs/composition-api";
function useLanguages() {
  const { store, i18n } = useContext();
  const currentLanguage = ssrRef(void 0, "current-lang");
  const languagesFromStore = store.getters["config/getLanguages"];
  const languages = languagesFromStore.map((languageFromStore) => ({
    name: languageFromStore.name,
    code: languageFromStore.code,
    default: languageFromStore.default
  }));
  const getLanguageByCode = (code) => languages?.find((language) => language.code === code);
  currentLanguage.value = getLanguageByCode(i18n.locale);
  i18n.onLanguageSwitched = (_, newLocale) => {
    currentLanguage.value = getLanguageByCode(newLocale);
  };
  return {
    languages,
    currentLanguage
  };
}
;
export {
  useLanguages as default
};
